import { Button, Modal } from "react-bootstrap";
import { OrderItemSummary } from "../../../types/Order/orderItemSummary";
import { StyledModalTitle } from "../../../@ui/StyledModalTitle";
import ThemedModal from "../../../@ui/Modal/ThemedModal";

interface DeleteDataModalProps {
  orderItem: OrderItemSummary;
  onConfirm: (orderItem: OrderItemSummary) => void;
  onClose: () => void;
}

const DeleteDataModal = ({
  orderItem,
  onConfirm,
  onClose,
}: DeleteDataModalProps) => {
  return (
    <ThemedModal show={true} centered>
      <Modal.Header className="bg-primary text-white">
        <StyledModalTitle>Delete Data</StyledModalTitle>
      </Modal.Header>
      <Modal.Body>
        <p>
          I confirm that the data associated with{" "}
          <strong>{orderItem.product}</strong> has been permanently deleted from
          my system.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={() => onConfirm(orderItem)}>
          Delete Data
        </Button>
      </Modal.Footer>
    </ThemedModal>
  );
};

export default DeleteDataModal;
